// this tiny util is there to help with TS type inference, for example:
// I have an array of (string | undefined) and I want to filter out the undefined values
// when filtering without this util, I have to cast the return value as string[]
// with this util, TS will be able to infer it by itself.
export const isTruthy = <TValue>(
  value: TValue | undefined | null | false
): value is TValue => !!value;
